import { RootState } from '../types';

// eslint-disable-next-line max-len
export const notificationSelector = (state: RootState) => (state.notifications.length > 0 ? state.notifications[0] : undefined);
